// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"86":"fc46d2df","299":"0a49b475","597":"76b03c72","818":"d812a5b0","958":"3f9736ab","964":"50b9c5d2","993":"75e295d3"}[chunkId] + ".js";
};